import { render, staticRenderFns } from "./SysMenuList.vue?vue&type=template&id=49b7a392&xmlns%3Av-bind=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml"
import script from "./SysMenuList.vue?vue&type=script&lang=js"
export * from "./SysMenuList.vue?vue&type=script&lang=js"
import style0 from "./SysMenuList.vue?vue&type=style&index=0&id=49b7a392&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports